<div class="container-fluid">
  <div class="row">
    <div class="col-12" *ngIf="isLoading">
      <app-busy [message]="message"></app-busy>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <img src="../../../../../assets/newimg/arrow-1-3@2x.png"  (click)="onBack()" style="cursor: pointer;margin: 10px;"/>
      <div class="contact-details opensans-semi-bold-sapphire-30px">
        <span class="opensans-semi-bold-sapphire-30px"> Invoice Details for {{invoicedetails.InvoiceNumber}}</span>
      </div>
      <div class="rectangle-34"></div>

      <div class="row">
        <div class="col-md-6 pt-4">
          Account Name:
        </div>
        <div class="col-md-6 pt-4">
          {{debtoraccount.customer_name}}
        </div>
        <div class="col-md-6  pt-4">
          Account ID:
        </div>
        <div class="col-md-6  pt-4">
          {{debtoraccount.customer_code}}
        </div>
        <div class="col-md-6  pt-4">
          Account balance:
        </div>
        <div class="col-md-6  pt-4">
          {{debtoraccount.AccountBalance * -1 ? (debtoraccount.AccountBalance * -1 | currencyFormat) : 'R 0.00' }}
        </div>
        <div class="col-md-6  pt-4">
          Contact Person:
        </div>
        <div class="col-md-6  pt-4">
          {{debtoraccount.contact_person}}
        </div>
        <div class="col-md-6  pt-4">
          Email Address:
        </div>
        <div class="col-md-6  pt-4">
          {{debtoraccount.email}}
        </div>

      </div>

    </div>
    <br/>
    <br/>

    <div class="col-12">
      <br/>
      <br/>
      <table class="table table-sm table-striped" style="border-top:none;">
        <thead class="" style="background:white!important;border-top:none;">
        <tr style="vertical-align:middle;">

          <th scope="col">Item Code</th>
          <th scope="col">Description</th>
          <th scope="col">Price Per Unit</th>
          <th scope="col">Quantity</th>
          <th scope="col">Total</th>

        </tr>
        </thead>
        <tr *ngFor="let invoiceitem of invoicedetails.invoiceItems | paginate: { itemsPerPage: 15, currentPage: page }">
          <td>{{invoiceitem.ItemCode}}</td>
          <td>{{invoiceitem.Description}}</td>
          <td class="text-right">{{invoiceitem.unit_price ? (invoiceitem.unit_price | currencyFormat) : 'R 0.00' }}</td>
          <td class="text-center">{{invoiceitem.quantity}}</td>
          <td class="text-right">{{invoiceitem.line_total ? (invoiceitem.line_total| currencyFormat) : 'R 0.00' }}</td>
        </tr>
        <tfoot>
        <!-- <tr *ngIf="invoicedetails.invoiceItems.length > 0">
          <td colspan="9" class="rm-brd">
            <pagination-controls (pageChange)="page = $event" style="margin:0px;padding:0px;"></pagination-controls>
          </td>
        </tr> -->
        <tr *ngIf="count===0">
          <td colspan="9" class="rm-brd">
            <span class="text-info text-small">No Transcations Available for this invoice.</span>
          </td>
        </tr>
        </tfoot>
      </table>
    </div>

  </div>
</div>
<div class="text-right">
  <b>Invoice Total: </b>{{invoicedetails.InclusiveTotal ? (invoicedetails.InclusiveTotal| currencyFormat) : 'R 0.00' }}
</div>
<br/>
<br/>
  <div class="col-12">
    <br/>
    <br/>
    <div class="button-container">

      <button class="btn btn-outline-custom" type="submit" (click)="emailInvoice()"    data-target="#myModal" title="Email your statement">
        Email
      </button>
      &nbsp; &nbsp;&nbsp;
      <button title="Download the statement" class="btn-add_2 btn" (click)="downloadInvoice()" type="submit">Download</button>
    </div>
  </div>


